'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'bolt';
var width = 448;
var height = 512;
var aliases = [9889,"zap"];
var unicode = 'f0e7';
var svgPathData = 'M303.5 184.4L338.9 49.8 352 0 310.8 30.9 32 240l0 48 88.3 5.9 32.5 2.2-8.3 31.5L109.1 462.2 96 512l41.2-30.9L416 272l0-48-88.3-5.9-32.5-2.2 8.3-31.5zM384 253.9l0 2.1L150.3 431.2l33.4-127 9.9-37.5L155 264.1l-91-6.1 0-2.1L297.7 80.8l-33.4 127-9.9 37.5 38.7 2.6 91 6.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBolt = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;